export function shuffleArray<T>(items: T[]): T[] {
  const result = [...items];

  for (let index = result.length - 1; index > 0; index--) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [result[index], result[swapIndex]] = [result[swapIndex], result[index]];
  }

  return result;
}

export function selectBalancedItems<T>(topicPools: T[][], count: number): T[] {
  const pools = shuffleArray(topicPools.map((pool) => shuffleArray(pool))).filter(
    (pool) => pool.length > 0,
  );

  if (count <= 0 || pools.length === 0) {
    return [];
  }

  const selected: T[] = [];
  const positions = new Array(pools.length).fill(0);

  while (selected.length < count) {
    let addedInCycle = false;

    for (let poolIndex = 0; poolIndex < pools.length && selected.length < count; poolIndex++) {
      const pool = pools[poolIndex];
      const position = positions[poolIndex];

      if (position < pool.length) {
        selected.push(pool[position]);
        positions[poolIndex] = position + 1;
        addedInCycle = true;
      }
    }

    if (!addedInCycle) {
      break; // Stop if we've exhausted all available questions to prevent duplicates
    }
  }

  return selected;
}